<h2 class="name" i18n="@@condiciones_del_alojamiento">Condiciones del Alojamiento</h2>
<mb-alert type="notification">
  <mb-alert-description>
    <span class="text" [innerHtml]="accommodationFee"></span>
    ... <span (click)="toggleModal()" i18n="@@ver_mas" class="show-more">Ver más</span>
  </mb-alert-description>
</mb-alert>
